module.exports = __webpack_public_path__ + "static/media/error.e2ee219c.svg";